export default "__VITE_ASSET__cf45d1c9__$_?nuxt_component=async&nuxt_component_name=SvgoArrow__"